import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  delete(event) {
    event.preventDefault()

    const link = event.currentTarget
    const url = link.dataset.url

    if (!confirm('Are you sure?')) {
      return
    }

    fetch(url, {
      method: 'DELETE',
      headers: {
        'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content,
        'Accept': 'application/json'
      }
    })
    .then(response => response.json())
    .then(data => {
      window.location.reload()
    })
    .catch(error => {
      console.error('Error deleting entry:', error)
    })
  }

  deleteTransfer(event) {
    event.preventDefault()

    const link = event.currentTarget
    const url = link.dataset.url

    if (!confirm('Are you sure you want to delete this transfer? This will delete both entries.')) {
      return
    }

    fetch(url, {
      method: 'DELETE',
      headers: {
        'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content,
        'Accept': 'application/json'
      }
    })
    .then(response => response.json())
    .then(data => {
      window.location.reload()
    })
    .catch(error => {
      console.error('Error deleting transfer:', error)
    })
  }
  
  duplicate(event) {
    event.preventDefault()

    const link = event.currentTarget
    const url = link.dataset.url

    fetch(url, {
      method: 'GET',
      headers: {
        'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content,
        'Accept': 'application/json'
      }
    })
    .then(response => response.json())
    .then(data => {
      window.location.reload()
    })
    .catch(error => {
      console.error('Error duplicating entry:', error)
    })
  }

  check(event) {
    event.preventDefault()

    const link = event.currentTarget
    const url = link.dataset.url

    fetch(url, {
      method: 'GET',
      headers: {
        'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content,
        'Accept': 'application/json'
      }
    })
    .then(response => {
      window.location.reload()
    })
    .catch(error => {
      console.error('Error checking entry:', error)
    })
  }

  transfer(event) {
    event.preventDefault()

    const link = event.currentTarget
    const url = link.dataset.url

    fetch(url, {
      method: 'GET',
      headers: {
        'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content,
        'Accept': 'application/json'
      }
    })
    .then(response => {
      window.location.reload()
    })
    .catch(error => {
      console.error('Error transferring entry:', error)
    })
  }
}

